import User from "views/parent/User.js";
import UserMg from "views/parent/UserMg.js";
import Logout from "views/Logout.js";

import logoutImg from "assets/img/sidebar/logout.png";
import profileImg from "assets/img/sidebar/profile.png";
import childImg from "assets/img/sidebar/child.png";

var routesParent = [
  {
    path: "/user",
    name: "プロフィール編集",
    icon: "nc-icon nc-single-02",
    onImg:true,
    img:profileImg,
    component: User,
    layout: "/parent",
  },
  {
    path: "/userMg",
    name: "子供情報",
    icon: "nc-icon nc-circle-10",
    onImg:true,
    img:childImg,
    component: UserMg,
    layout: "/parent",
  },
  {
    path: "/logout",
    name: "ログアウト",
    icon: "nc-icon nc-share-66",
    onImg:true,
    img:logoutImg,
    component: Logout,
    layout: "/admin",
  },
 ];

 export default routesParent;